import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'projects/services/src/app/API/user.service';
import { SectorsService } from 'projects/services/src/app/API/sectors.service';
import { ValidationService } from 'projects/services/src/app/validation.service';
import { TotBatchService } from 'projects/services/src/app/API/tot-batch.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { ScriptLoaderService } from 'projects/services/src/app/script-loader.service';
import { GeographiesService } from 'projects/services/src/app/API/geographies.service';
import { disclaimerCertidicationAccessorAndTrainer } from 'projects/shared/src/app/shared/constants/constants';

import * as moment from 'moment';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { Location } from '@angular/common';

declare var toastr: any;
declare const swal: any;

const TYPES = {
	BASIC: 'Basic',
	ADVANCED: 'Advanced'
}
@Component({
	selector: 'app-applicant-advance-certification',
	templateUrl: './applicant-advance-certification.component.html',
	styleUrls: ['./applicant-advance-certification.component.css']
})
export class ApplicantAdvanceCertificationComponent implements OnInit, AfterViewInit {

	advanceCerificationForm: FormGroup;
	trainingModels: any = [];
	certificateDetails: any;
	certificateData: any;
	currentUser: any;
	jobRoles: any;
	countries: any = [];
	sectors: any;
	states: any;
	districts: any;
	disclaimer: any;

	dateId1 = 'certificationIssueDate';
	showField = false;
	showUpload = true;
	loginType: any;

	academyList = [
		{
			'id': "1",
			'name': 'National Academy of Construction'
		},
		{
			'id': "2",
			'name': 'Northen India Textile Research Association',
		},
		{
			'id': "3",
			'name': 'Larsen & Toubro Limited'
		},
		{
			'id': "4",
			'name': 'Tata STRIVE'
		}
	]

	typeOfCertification = [
		{
			'id': 1,
			'name': 'Basic'
		},
		{
			'id': 2,
			'name': 'Advanced'
		}
	]

	constructor(
		private scriptLoaderService: ScriptLoaderService,
		private geographiesService: GeographiesService,
		private currentUserService: CurrentUserService,
		private totBatchService: TotBatchService,
		private activatedRoute: ActivatedRoute,
		private sectorService: SectorsService,
		private userService: UserService,
		private formBuilder: FormBuilder,
		private location: Location,
		private router: Router

	) {
		this.certificateData = {
			type: this.activatedRoute.snapshot.queryParams.batchType,
			certReqId: this.activatedRoute.snapshot.queryParams.certReqId,
			jobrole: this.activatedRoute.snapshot.queryParams.qpCode,
			tab: this.activatedRoute.snapshot.queryParams.tab,
			userName: this.activatedRoute.snapshot.queryParams.userName,
			sectorId: this.activatedRoute.snapshot.queryParams.sectorId
		}
		this.disclaimer = disclaimerCertidicationAccessorAndTrainer.disclaimer;
		this.currentUser = this.currentUserService.decodeToken();
		this.loginType = this.currentUser.role;
		this.advancedCertificationUploadForm();
		this.getCertificateDetails();
	}

	ngOnInit() {
		this.getSectors();
		this.getStates();
		this.getJobRoles();
		this.getCountries();
		this.getTrainingMdels();
	}

	ngAfterViewInit() {
		this.scriptLoaderService.addScriptTagToElementDOM(
			'../../../assets/demo/default/custom/components/forms/widgets/bootstrap-datepicker.js'
		);
	}

	advancedCertificationUploadForm() {
		this.advanceCerificationForm = this.formBuilder.group({
			sector: ['', [Validators.required]],
			jobRole: ['', [Validators.required]],
			trainingModel: ['', [Validators.required]],
			typeOfCertification: ['', Validators.required],
			academy: ['', Validators.required],
			country: ['', Validators.required],
			state: ['', [Validators.required]],
			district: ['', [Validators.required]],
			certificateId: ['', [Validators.maxLength(30), Validators.pattern('^[A-Za-z0-9][A-Za-z0-9-/,&()%$#@!`~\|?>< \s\']*$')]],
			certificateIssueDate: [null],
			advancedCertificate: [null, [ValidationService.fileValidator, ValidationService.fileTypeValidator('png', 'jpg', 'pdf', 'jpeg'), ValidationService.fileSizeValidator(5)]],
			remarkToSsc: [null, [Validators.maxLength(500), Validators.pattern('^[A-Za-z0-9][A-Za-z0-9-/,.&()%$#@!`~\\n|?>< \s\']*$')]],
			declaration: [false, [Validators.required]]
		})
	}

	getCertificateDetails() {
		this.userService.getParticularJobRoleCertificateDetails(this.certificateData.tab, this.certificateData).subscribe(res => {
			this.certificateDetails = res.data[0];
			if (this.certificateData.tab === 'Rejected') {
				this.advanceCerificationForm.get('sector').patchValue(this.certificateDetails.sector);
				const jobRoleDetails = {
					jobRoleId: this.certificateDetails.jobRoleId,
					version: this.certificateDetails.version,
					jobRoleDesc: this.certificateDetails.jobRoleDesc,
					jobName: this.certificateDetails.jobName,
					nsqfLevel: this.certificateDetails.nsqfLevel,
				}
				this.advanceCerificationForm.get('jobRole').patchValue(jobRoleDetails);
				this.advanceCerificationForm.get('trainingModel').patchValue(this.certificateDetails.batchType);
				this.advanceCerificationForm.get('typeOfCertification').patchValue(this.certificateDetails.certificateDetails.typeOfCertification);
				this.advanceCerificationForm.get('academy').patchValue(this.certificateDetails.academy);
				if (this.certificateDetails.address) {
					this.getDistricts(this.certificateDetails.address.state.id)
					this.advanceCerificationForm.get('state').patchValue(this.certificateDetails.address.state);
					this.advanceCerificationForm.get('district').patchValue(this.certificateDetails.address.district);
				}
				this.advanceCerificationForm.get('certificateId').patchValue(this.certificateDetails.certificateDetails.certificateID);
				if (this.certificateDetails.certificateDetails.certificateIssueDate) {
					const patchIsDate = moment(this.certificateDetails.certificateDetails.certificateIssueDate).format('DD/MM/YYYY');
					this.advanceCerificationForm.get('certificateIssueDate').patchValue(patchIsDate);
				}
				if (this.certificateDetails.certificateDetails.certificateStatus === 'PENDING') {
					this.showUpload = true;
				}
				this.advanceCerificationForm.get('certificateId').patchValue(this.certificateDetails.certificateDetails.certificateID);
				this.advanceCerificationForm.get('remarkToSsc').patchValue(this.certificateDetails.remarks.toSSC.comment);
				this.patchCountryValue();
			} else {
				this.mapCertificateDetails();

			}
		})
	}

	mapCertificateDetails() {
		this.advanceCerificationForm.get('sector').patchValue(this.certificateDetails.sector);
		const jobRoleDetails = {
			jobRoleId: this.certificateDetails.jobRoleId,
			version: this.certificateDetails.version,
			jobRoleDesc: this.certificateDetails.jobRoleDesc,
			jobName: this.certificateDetails.jobName,
			nsqfLevel: this.certificateDetails.nsqfLevel,
		}
		this.advanceCerificationForm.get('jobRole').patchValue(jobRoleDetails);
		this.advanceCerificationForm.get('typeOfCertification').patchValue(TYPES.ADVANCED);

	}

	getJobRoles() {
		const sector = Number(this.certificateData.sectorId);
		this.sectorService.getJobRoles(sector).subscribe(res => {
			if (res.data) {
				if (res.data.length > 0) {
					this.jobRoles = res.data.map(r => {
						return {
							jobRoleId: r.qpCode ? r.qpCode : '',
							version: r.version ? r.version : '',
							jobRoleDesc: r.jobRoleDesc ? r.jobRoleDesc : '',
							jobName: r.jobRole ? r.jobRole : '',
							nsqfLevel: r.nsqfLevel ? r.nsqfLevel : '',
							jobroleName: r.qpCode && r.jobRole ? r.jobRole + ' (' + r.qpCode + ') ' + '- ' + 'v' + r.version : '',
						}
					});
				} else {
					this.jobRoles = [];
					toastr.error('No Job Role Found');
				}
			}
		})
	}

	getTrainingMdels() {
		this.totBatchService.getAllTrainingModels().subscribe(res => {
			if (this.currentUser.role === "Trainer") {
				for (let i = 0; i < res.length; i++) {
					if (res[i].type === "TOTADVANCED") {
						this.trainingModels.push(res[i])
						this.advanceCerificationForm.get('trainingModel').patchValue(res[i]);
					}
				}
			}
			if (this.currentUser.role === "Assessor") {
				for (let i = 0; i < res.length; i++) {
					if (res[i].type === "TOAADVANCED") {
						this.trainingModels.push(res[i])
						this.advanceCerificationForm.get('trainingModel').patchValue(res[i]);
					}
				}
			}
		})
	}

	assignedDate(event) {
		if (event.target.value) {
			const [day, month, year] = (event.target.value).split('/');
			const formattedDate = moment(new Date(year, month - 1, day)).format('DD/MM/YYYY');
			console.log('from date', formattedDate);
			this.advanceCerificationForm.get('certificateIssueDate').setValue(formattedDate);
		}
	}

	patchCountryValue() {
		if (this.certificateDetails.originationCategory === 'domestic') {
			const defaultValue = {
				code: 91,
				country: 'India',
				countryId: 'IN'
			}
			this.showField = true;
			this.countries.push(defaultValue);
			this.advanceCerificationForm.get('country').setValue(defaultValue);
			this.advanceCerificationForm.get('country').disable();
		} else if (this.certificateDetails.originationCategory === 'international') {
			this.showField = false
			if (this.certificateDetails && this.certificateDetails.address) {
				this.advanceCerificationForm.get('country').setValue(this.certificateDetails.address.country)
				this.advanceCerificationForm.get('country').disable();
			}
			this.advanceCerificationForm.get('state').setValidators([]);
			this.advanceCerificationForm.get('state').updateValueAndValidity();
			this.advanceCerificationForm.get('district').setValidators([]);
			this.advanceCerificationForm.get('district').updateValueAndValidity();
		}
	}

	submitCetificationDetails() {
		if (this.advanceCerificationForm.valid) {
			const formData = this.advanceCerificationForm.getRawValue();
			const requestData = this.mapRequestData(formData);
			this.userService.addCertificate(requestData, 'create').subscribe(res => {
				swal('Certificate Submitted Successfully to SSC', `Please wait for the concerned Sector Skill Council to approve certification`, 'success');
				this.router.navigate(['../applicant-certification-list'], {
					relativeTo: this.activatedRoute
				})
			}, err => {
				console.log(err);
			})
		} else {
			toastr.error('Please fill all details');
		}
	}

	mapRequestData(request) {
		const formData = request;
		let certifcateIssueDate;
		if (formData.certificateIssueDate) {
			const tempDate = Helpers.toDateFromCalendar(formData.certificateIssueDate);
			certifcateIssueDate = tempDate.toISOString();
		}
		console.log(formData);
		const data = {
			'batchType': formData.trainingModel,
			'applicantID': this.certificateData.userName,
			'jobRoleId': formData.jobRole.jobRoleId ? formData.jobRole.jobRoleId : '',
			'version': formData.jobRole.version ? formData.jobRole.version : '',
			'jobRoleDesc': formData.jobRole.jobRoleDesc ? formData.jobRole.jobRoleDesc : '',
			'jobName': formData.jobRole.jobName ? formData.jobRole.jobName : '',
			'nsqfLevel': formData.jobRole.nsqfLevel ? formData.jobRole.nsqfLevel : '',
			'sector': formData.sector ? formData.sector : '',
			'certReqId': Number(this.certificateData.certReqId),
			'academy': formData.academy ? formData.academy : '',
			'address': {
				'country': {
					'name': formData.country.country ? formData.country.country : formData.country.name ? formData.country.name : '',
					'id': formData.country.code ? formData.country.code : 0,
					'countryCode': formData.country.countryId ? formData.country.countryId : formData.country.countryCode ? formData.country.countryCode : ''
				},
				'state': {
					'name': formData.state.name ? formData.state.name : '',
					'id': formData.state.id ? formData.state.id : 0
				},
				'district': {
					'name': formData.district.name ? formData.district.name : '',
					'id': formData.district.id ? formData.district.id : 0
				}
			},
			'remarks': {
				'toSSC': {
					'comment': formData.remarkToSsc ? formData.remarkToSsc : '',
				}
			},
			'certificateDetails': {
				'certificateID': formData.certificateId ? formData.certificateId : '',
				'certificateIssueDate': certifcateIssueDate ? certifcateIssueDate : null,
				'certificateType': this.currentUser.role,
				'supportingDocumentURLDetails': {
					'location': formData.advancedCertificate ? formData.advancedCertificate : ''
				},
				'typeOfCertification': formData.typeOfCertification
			}
		}
		return data;
	}

	//get Dropdowns
	getCountries() {
		this.geographiesService.getCountries().subscribe(country => {
			console.log(country);
			if (country) {
				this.countries = country;
				this.patchCountryValue();
			}
		})
	}

	getStates() {
		this.geographiesService.getStates().subscribe(res => {
			this.states = res.states.map(r => {
				return {
					id: r.code,
					name: r.name
				}
			});
		})
	}

	getDistricts(id?) {
		const stateId = this.advanceCerificationForm.get('state').value.id ? this.advanceCerificationForm.get('state').value.id : id;
		this.geographiesService.getDistricts(stateId).subscribe(res => {
			this.districts = res.districts.map(r => {
				return {
					id: r.code,
					name: r.name
				}
			});
			console.log(res);
		})
	}

	getSectors() {
		this.sectorService.getSectors().subscribe(res => {
			this.sectors = res.map(r => {
				return {
					name: r.sector,
					id: r.sectorID
				}
			});
		})
	}

	showCountry(item, formControlValue): boolean {
		if (item && formControlValue) {
			return ((item.countryId === formControlValue.countryCode) || (item.countryId === formControlValue.countryId) || (item.country === formControlValue.name));
		} else {
			return false;
		}
	}

	// Compare Functions
	compareSectors(item, formControlValue): boolean {
		if (item && formControlValue) {
			return ((item.id === formControlValue.id));
		} else {
			return false;
		}
	}

	compareAcademicType(item, formControlValue): boolean {
		if (item && formControlValue) {
			return ((item.name === formControlValue.name));
		} else {
			return false;
		}
	}

	compareCertificationType(item, formControlValue): boolean {
		if (item && formControlValue) {
			return ((item === formControlValue));
		} else {
			return false;
		}
	}

	compareJobRoleName(item, formControlValue): boolean {
		if (item && formControlValue) {
			return ((item.jobRoleId === formControlValue.jobRoleId));
		} else {
			return false;
		}
	}

	compareTrainingModel(item, formControlValue): boolean {
		if (item && formControlValue) {
			return ((item.name === formControlValue.name));
		} else {
			return false;
		}
	}

	compareStateAndDistrict(item, formControlValue): boolean {
		if (item && formControlValue) {
			return ((item.id === formControlValue.id));
		} else {
			return false;
		}
	}

	goBack() {
		this.location.back();
	}

}
